import { X, ExternalLink } from "lucide-react";

const ROWS = [
  { key: "organization", label: "Organization" },
  { key: "offer", label: "What they offer" },
  { key: "cost", label: "Cost" },
  { key: "address", label: "Location" },
  { key: "fit", label: "Match" },
  { key: "website", label: "Website" },
  { key: "why_recommended", label: "Why recommended" },
  { key: "more_info", label: "More about this program" },
];

const cellValue = (program, key) => {
  if (key === "fit") {
    const fit = program.fit === "partial" ? "Partial fit" : "Strong fit";
    return program.fit_note ? `${fit} — ${program.fit_note}` : fit;
  }
  return program[key];
};

export function ProgramCompareModal({ programs = [], onClose }) {
  if (programs.length === 0) return null;
  return (
    <div className="fixed inset-0 bg-[#1e3a5f]/70 backdrop-blur-sm z-[180] flex items-center justify-center p-4" onClick={onClose} data-testid="compare-modal-overlay">
      <div
        className="bg-[#f5f0e8] rounded-2xl w-full max-w-5xl shadow-2xl max-h-[88vh] flex flex-col overflow-hidden"
        onClick={(e) => e.stopPropagation()}
        data-testid="compare-modal"
      >
        <div className="bg-[#1e3a5f] px-5 py-4 flex items-center justify-between gap-3">
          <div>
            <h2 className="text-[#f5f0e6] font-bold">Compare programs</h2>
            <p className="text-xs text-[#c9a962]">{programs.length} programs side by side</p>
          </div>
          <button
            onClick={onClose}
            className="text-[#f5f0e6]/70 hover:text-[#f5f0e6] p-1.5 rounded-md hover:bg-white/10"
            data-testid="compare-modal-close-btn"
            aria-label="Close comparison"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="overflow-auto">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr>
                <th className="sticky left-0 z-10 bg-[#e8e0d0] text-left px-4 py-3 text-xs font-semibold uppercase tracking-wide text-[#1e3a5f]/60 w-44">Feature</th>
                {programs.map((p, i) => (
                  <th key={`${p.program_name}-${i}`} className="bg-[#e8e0d0] text-left px-4 py-3 text-[#1e3a5f] font-bold align-top min-w-[14rem]" data-testid={`compare-col-${i}`}>
                    {p.program_name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ROWS.map((row) => (
                <tr key={row.key} className="border-t border-[#e8e0d0] align-top" data-testid={`compare-row-${row.key}`}>
                  <td className="sticky left-0 z-10 bg-[#efe8da] px-4 py-3 text-xs font-semibold uppercase tracking-wide text-[#1e3a5f]/60">{row.label}</td>
                  {programs.map((p, i) => {
                    const value = cellValue(p, row.key);
                    return (
                      <td key={i} className="bg-white px-4 py-3 text-[#1e3a5f] border-l border-[#e8e0d0]">
                        {!value ? (
                          <span className="text-[#1e3a5f]/30">—</span>
                        ) : row.key === "website" && String(value).startsWith("http") ? (
                          <a href={value} target="_blank" rel="noopener noreferrer" className="inline-flex items-start gap-1.5 text-[#1e3a5f] underline hover:text-[#2a4d6e] break-all">
                            <ExternalLink className="w-3.5 h-3.5 mt-0.5 shrink-0 text-[#c9a962]" />
                            {value}
                          </a>
                        ) : (
                          value
                        )}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
